var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _polygon7, _path2, _path3, _path4, _path5, _polygon8, _polygon9, _polygon0, _polygon1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 708 111.9",
    style: {
      enableBackground: "new 0 0 708 111.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5EB3E4;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:#84C2EA;}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:#53575A;}\n\t.st10{fill:#00ADEE;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.8,12.2 0,12.2 36.9,73.4  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "37,81.5 73.6,81.5 73.6,20.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.075,
    y1: 28.425,
    x2: 88.825,
    y2: 77.175,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "37,81.5 73.6,81.5 73.6,20.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,20.6 0,81.5 36.6,81.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -15.225,
    y1: 77.175,
    x2: 33.525,
    y2: 28.425,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,20.6 0,81.5 36.6,81.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.375,
    y1: 64.125,
    x2: 61.425,
    y2: 113.175,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#000000"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "73.8,12.2 36.9,73.4 0,12.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.9,17.3L193.9,17.3C194,17.3,193.9,17.3,193.9,17.3z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.9,17.3 193.9,17.3 193.9,17.3  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.9,43.4h34.7c-1.6-18.1-16.4-32.5-34.7-33.5V43.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.9446,
    y1: 63.1763,
    x2: 192.1119,
    y2: 99.9214,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.9,43.4h34.7c-1.6-18.1-16.4-32.5-34.7-33.5V43.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,47.6v-3v-1.2V9.9c-19.4,1.1-34.8,17.2-34.8,36.9c0,20.4,16.5,36.9,36.9,36.9 c20.1,0,36.5-16.1,36.9-36.2L191.7,47.6L191.7,47.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.033,
    y1: 35.0131,
    x2: 166.5783,
    y2: 91.5673,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#000000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.7,47.6v-3v-1.2V9.9c-19.4,1.1-34.8,17.2-34.8,36.9c0,20.4,16.5,36.9,36.9,36.9 c20.1,0,36.5-16.1,36.9-36.2L191.7,47.6L191.7,47.6z"
  })))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "152.3,75.4 152.3,12.2 78.4,12.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.675,
    y1: 66.525,
    x2: 149.5861,
    y2: 103.4361,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    style: {
      stopColor: "#0B0A0A",
      stopOpacity: 0.5962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#000000"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "152.3,75.4 152.3,12.2 78.4,12.2  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.4,17.8 78.4,81.5 152.3,81.5 152.3,81.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.4386,
    y1: 26.5111,
    x2: 115.8047,
    y2: 63.8919,
    gradientTransform: "matrix(1 0 0 -1 0 113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#231F20",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03684409,
    style: {
      stopColor: "#211D1E",
      stopOpacity: 0.03878325
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6023,
    style: {
      stopColor: "#090808",
      stopOpacity: 0.634
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#000000"
    }
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "78.4,17.8 78.4,81.5 152.3,81.5 152.3,81.4  "
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.1,11.6h11.4l5.4,15.5l2.8,7.8h0.4l3-8l5.6-15.3h10.4l4.1,37.8h-9.5l-1.3-13.5l-1.1-10.1H321l-3.7,10 l-5.1,13.6h-7.1l-4.7-13.7l-3.5-10.2h-0.3l-1,10.3l-1.4,13.6h-8.6L290.1,11.6z M340.4,49.4h8.2V25.9h0.2l18.3,23.5h7.8V11.6h-8.2 v23h-0.2l-18.5-23h-7.6L340.4,49.4L340.4,49.4z M381.8,31.1c0,12.8,8,19,19.9,19c5,0,9.6-1.3,13.9-3.6V29.6h-9.1v13.1 c-1.2,0.2-2.3,0.3-3.6,0.3c-7.6,0-11.7-4.7-11.7-12.9c0-8.1,5.4-12.1,11.5-12.1c3.9,0,8.9,0.8,12.6,3.2v-8 c-2.5-1-7.1-2.3-12.8-2.3C389.9,10.9,381.8,19,381.8,31.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M311.1,82.5h-21.4v16.9h-4.2V63.2h4.2v15.9h21.4V63.2h4.2v36.2h-4.2V82.5z M321.5,99.4h3.9l4.3-11.6H343 l3.5,11.6h4.5l-11.8-36.2h-3.8L321.5,99.4z M333.2,78.2l3.7-10.1h0.2l3,10.1l1.8,6.1h-11L333.2,78.2z M383.5,63.2h-4.3L371.3,84 l-3.8,10.3h-0.3l-3.6-10.4l-7.1-20.6H352l13,36.2h3.7L383.5,63.2z M382.7,99.4h3.9l4.3-11.6h13.3l3.5,11.6h4.5l-11.8-36.2h-3.9 L382.7,99.4z M394.5,78.2l3.7-10.1h0.2l3,10.1l1.8,6.1h-11L394.5,78.2z M442,63.2h-4.3L431.4,75l-4,7.4h-0.2L423,75l-6.6-11.7 h-4.5l13,22.4v13.8h4.1V86L442,63.2z M444.5,82c0,9.8,5.4,18,16.2,18c11.6,0,17-9.7,17-19.6c0-9.3-5-17.6-16-17.6 C450.5,62.7,444.5,71.3,444.5,82 M473.2,81c0,8.6-4,15.5-12.4,15.5c-7.8,0-11.9-6.5-11.9-15.2c0-9.4,4.7-15.1,12.4-15.1 C468.9,66.1,473.2,72.2,473.2,81 M486.1,99.4h21.2V96h-17V63.2h-4.2V99.4z M513.6,99.4h21.2V96h-17V63.2h-4.2V99.4z M536.9,99.4 h3.9l4.3-11.6h13.3l3.5,11.6h4.5l-11.8-36.2h-3.9L536.9,99.4z M548.6,78.2l3.7-10.1h0.2l3,10.1l1.8,6.1h-11L548.6,78.2z  M573.5,99.4h4.2v-14h4.2c1.4,0,2.7-0.1,3.9-0.2l8.8,14.3h5.1l-10-15.3c4.7-1.8,7-5.5,7-10c0-7.6-5-10.9-12.3-10.9h-10.8v36.1 H573.5z M582.9,66.7c6.2,0,9.6,2.4,9.6,7.6c0,6.4-5,7.6-10.8,7.6h-3.9V66.7H582.9z M606.5,99.4h4.2V63.2h-4.2V99.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTr);
export default __webpack_public_path__ + "static/media/Logo-tr.aaaa414a853e36354abc49ed5fad8aa6.svg";
export { ForwardRef as ReactComponent };